import { render, staticRenderFns } from "./SpreadsheetClone.vue?vue&type=template&id=09c2c98f"
import script from "./SpreadsheetClone.vue?vue&type=script&lang=ts"
export * from "./SpreadsheetClone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports